import formatAndDropDecimal from '~/utilities/formatAndDropDecimal';
import { LineItem } from '../SptPriceDetailsContent/WithoutSoftpull/Card.styles';

type OwnProps = {
  tradeInCredit: number;
  card: 'once' | 'monthly';
  hasDeliveryCharge: boolean;
};

export default function TradeInSection({
  tradeInCredit,
  card,
  hasDeliveryCharge
}: OwnProps) {
  if (!tradeInCredit) return null;

  const positiveEquity = tradeInCredit > 0;
  const shippingCostDisclaimer = hasDeliveryCharge
    ? 'Trade-in value cannot be used for the nonrefundable shipping fee.'
    : '';
  const textToUse = {
    once: {
      positive: `Your trade-in value is applied to your purchase, reducing your total purchase price. ${shippingCostDisclaimer}`,
      negative:
        'Carvana will facilitate paying off the balance on your trade-in. Your total purchase price reflect the application of your trade-in to your purchase.'
    },
    monthly: {
      positive: `Your trade-in value is applied to your purchase, reducing your cash down payment and lowering your monthly payment. ${shippingCostDisclaimer}`,
      negative:
        'Carvana will facilitate paying off the balance on your trade-in. Your cash down payment and total amount financed reflect the application of your trade-in to your purchase.'
    }
  };

  return (
    <>
      <LineItem data-qa="trade-in-equity">
        <span>
          {positiveEquity ? 'Trade-in value' : 'Trade-in balance due'}
        </span>
        <span>
          {positiveEquity ? '- ' : ''}$
          {formatAndDropDecimal(Math.abs(tradeInCredit))}
        </span>
      </LineItem>
      <li className="text-grey-5 tl-body-s">
        {positiveEquity ? textToUse[card].positive : textToUse[card].negative}
      </li>
    </>
  );
}
